import * as React from "react";
import KnowladgeWhatIsLoriiniTest from "../containers/KnowladgeWhatIsLoriiniTest";

export default (props) => <KnowladgeWhatIsLoriiniTest {...props} />;
